<template>
  <div id="app">
    <router-view v-if="isReport || isLogin" />
    <layout v-else>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </layout>
    
  </div>
</template>

<script>
import Layout from '@/views/layout'
import { MQTT } from '@/utils/mqtt.js'
import { webInfo } from '@/api/user'

export default {
  components: { Layout },
  name: 'App',
  data () {
    return {
      currentHref: '/'
    }
  },
  computed: {
    isReport () {
      return this.currentHref.indexOf('/w/yhub') >= 0;
    },
    isLogin() {
      return this.currentHref.indexOf('/login') >= 0;
    }
  },
  watch: {
    '$route' (to, from) {
      console.log(from.path, to.path)
      this.currentHref = location.href
    }
  },
  mounted () {
    this.currentHref = location.href

    MQTT()
    this.getTitleIco()
  },

  methods: {

    getTitleIco () {
      webInfo().then(res => {
        if (res.resultCode == 1001 && res.resultModel) {
          this.$store.dispatch('setWebInfo', res.resultModel)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  min-width: 1200px;
}
// bootstrap
.clearfix:before  {
  display: table;
  content: " ";
  font-size: 0;
  height: 0;
}
.clearfix:after  {
  display: table;
  content: " ";
  clear: both;
  font-size: 0;
  height: 0;
}
.fr  {
  float: right;
}
.fl  {
  float: left;
}

.myTable .el-table__body tr:hover > td {
  background-color: #fff !important;
}
.searchWarp {
  display: flex;
  align-items: center;
}
.selectTab {
  display: inline-block;
  margin-left: 20px;
  .el-tabs__header {
    display: inline-block !important;
    margin-bottom: 0;
  }
  .el-tabs__nav {
    background: #dfe4ed6b;
    border-top: none;
  }
  .el-tabs__item {
    border-top: 1px solid #dfe4ed;
    height: 36px;
    line-height: 34px;
  }
  .el-tabs__item.is-active {
    background: #1990fc;
    border-bottom: 1px solid #1990fc;
    border-top: 1px solid #1990fc;
    color: #fff;
  }
  .el-tabs__item:nth-of-type(1).is-active {
    border-radius: 3px 0 0 0;
  }
  .el-tabs__item:nth-of-type(3).is-active {
    border-radius: 0 3px 0 0;
  }
}
.columnLineWarp {
  .el-icon-question {
    top: 3px;
    position: absolute;
    left: calc(50% + 60px);
  }
  .en,
  .de {
    left: calc(50% + 60px);
  }
  .kl,
  .zh,
  .ft {
    left: calc(50% + 30px);
  }
  .ja {
    left: calc(50% + 50px);
  }
}

.SummaryWarp {
  .el-icon-question {
    margin-left: 5px;
  }
}
.chargedRecordTable {
  tr th:nth-last-child(1),
  tr td:nth-last-child(1) {
    border-left: 1px solid #dfe6ec;
  }
  tbody tr:nth-of-type(1) td:nth-last-child(1) {
    border-top: 1px solid #dfe6ec;
  }
}


</style>
